<template>
  <v-container>
    <h1>แก้ไขห้องนวด</h1>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            sm="5"
            md="4"
          >
            <v-text-field
              v-model="name"
              :error-messages="nameErrors"
              label="ชื่อห้อง"
              filled
              @input="$v.name.$touch()"
              @blur="$v.name.$touch()"
            />
            <v-text-field
              v-model="roomType"
              :error-messages="roomTypeErrors"
              label="ประเภทห้อง"
              filled
              @input="$v.roomType.$touch()"
              @blur="$v.roomType.$touch()"
            />
            <v-btn
              depressed
              color="orange"
              block
              @click="onFormSubmit"
            >
              submit
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            sm="7"
            md="8"
          >
            <v-list dense>
              <v-subheader>
                เตียงในห้อง
              </v-subheader>
              <v-list-item
                v-for="bed in beds"
                :key="bed._id"
              >
                <v-list-item-content>
                  {{ bed.name }}
                </v-list-item-content>
                <v-list-item-action>
                  <v-row>
                    <v-btn
                      icon
                      @click="onDialogOpen(bed._id, bed.name)"
                    >
                      <v-icon small>
                        fas fa-edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      @click="onDeleteBed(bed._id)"
                    >
                      <v-icon small>
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-text-field
                    v-model="creatingBedName"
                    label="ชื่อห้อง"
                    color="orange"
                  />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon
                      small
                      color="grey lighten-1"
                      @click="onCreateBedSubmit"
                    >
                      fas fa-plus
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title>
          แก้ไขชื่อเตียง
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="bedName"
            label="ชื่อเตียง"
            color="orange"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="orange"
            depressed
            @click="onBedFormSubmit"
          >
            ตกลง
          </v-btn>
          <v-btn
            color="red"
            depressed
            @click="onDialogClose"
          >
            ยกเลิก
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';
import http from '@/http';

export default {
  name: 'RoomEditFormView',
  validations: {
    name: {
      required,
    },
    roomType: {
      required,
    },
  },
  data() {
    return {
      name: '',
      roomType: '',
      beds: [],
      dialog: false,
      selectedBedId: '',
      bedName: '',
      creatingBedName: '',
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) {
        errors.push('กรุณากรอกชื่อห้อง');
      }
      return errors;
    },
    roomTypeErrors() {
      const errors = [];
      if (!this.$v.roomType.$dirty) return errors;
      if (!this.$v.roomType.required) {
        errors.push('กรุณากรอกประเภทห้อง');
      }
      return errors;
    },
  },
  async created() {
    const { data } = await http.get(`/rooms/${this.$route.params.id}`);
    this.name = data.name;
    this.roomType = data.roomType;
    this.beds = data.beds;
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    onDialogClose() {
      this.selectedBedId = '';
      this.bedName = '';
      this.dialog = false;
    },
    onDialogOpen(id, name) {
      this.selectedBedId = id;
      this.dialog = true;
      this.bedName = name;
    },
    async onBedFormSubmit() {
      if (this.bedName) {
        await http.put(`/beds/${this.selectedBedId}`, { name: this.bedName });
        const { data } = await http.get(`/rooms/${this.$route.params.id}`);
        this.beds = [...data.beds];
        this.dialog = false;
        this.SET_ALERT(true);
        this.SET_ERROR(false);
        this.SET_ALERT_CONTEXT('บันทึกเตียงแล้ว');
      }
    },
    async onFormSubmit() {
      if (!this.$v.$invalid) {
        const data = {
          name: this.name,
          roomType: this.roomType,
        };
        await http.put(`/rooms/${this.$route.params.id}`, data);
        this.$router.push('/admin/rooms');
        this.SET_ALERT(true);
        this.SET_ERROR(false);
        this.SET_ALERT_CONTEXT('บันทึกห้องแล้ว');
      }
    },
    async onCreateBedSubmit() {
      if (this.creatingBedName) {
        await http.post('/beds', {
          roomId: this.$route.params.id,
          name: this.creatingBedName,
        });
        this.creatingBedName = '';
        const { data } = await http.get(`/rooms/${this.$route.params.id}`);
        this.beds = [...data.beds];
        this.SET_ALERT(true);
        this.SET_ERROR(false);
        this.SET_ALERT_CONTEXT('บันทึกเตียงแล้ว');
      }
    },
    async onDeleteBed(id) {
      await http.delete(`/beds/${id}`);
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('ลบเตียงแล้ว');
      const { data } = await http.get(`/rooms/${this.$route.params.id}`);
      this.beds = [...data.beds];
    },
  },
};
</script>
